// @ts-check
import React from 'react';

import BusComponent from '../BusComponent';
import { SELFSTORAGE_POINT_TYPE } from '../../enums/SelfStoragePointType';

/**
 * @typedef Props
 * @property {import('@turf/helpers').Feature} feature
 * @property {string} mapInstanceId
 * @property {string[]} searchFields
 *
 * @extends {BusComponent<Props>}
 */
class PointSearchResultListItem extends BusComponent {
    onClick = () => {
        const { mapInstanceId, feature } = this.props;

        const facilityType =
            feature.properties.category.toString() === 'construction'
                ? SELFSTORAGE_POINT_TYPE.SS_CONSTRUCTION
                : SELFSTORAGE_POINT_TYPE.SS_FACILITY;
        const visualReportProps = {
            report: 'selfstorage-point-info',
            pointType: facilityType,
            facilityId: feature.properties.facility_id,
        };
        this.emit('FEATURE_TO_LOCATION_ANALYSIS', {
            feature: feature,
            mapInstanceId: mapInstanceId,
            visualReportProps: visualReportProps,
        });
    };

    /**
     * Returns formatted title and secondary text for a search result.
     * Shows facility_id (in parentheses) before the title only if matched by facility ID.
     * Excludes facility_id from the secondary text.
     * @returns {{ title: string, other: string }} - The formatted title and supporting text for display.
     */

    formatResultItem = () => {
        const { searchFields, feature } = this.props;

        const { facility_id, foundByFacilityIdMatch } = feature.properties;

        const titleBase = searchFields
            .filter(searchField => searchField.isTitle)
            .map(searchField => feature.properties[searchField.property])
            .join('');

        const title =
            foundByFacilityIdMatch && facility_id
                ? `(${facility_id.replace(/^0+/, '')}) ${titleBase}`
                : titleBase;

        const other = searchFields
            .filter(searchField => !searchField.isTitle && searchField.property !== 'facility_id')
            .map(searchField => feature.properties[searchField.property])
            .join(', ');

        return { title, other };
    };

    render() {
        const resultItem = this.formatResultItem();

        const [first, second] = resultItem.other.split(',');
        const tooltipText = `${resultItem.title} -- ${first + ',' || ''} ${second || ''}`.trim();

        return (
            <li
                className="search-results__list-item"
                onClick={this.onClick}
                data-testid="map-facility-search-result"
            >
                <div
                    className="flex-it space-between center grow stretch-width"
                    title={tooltipText}
                >
                    <div className="flex-it stretch flex-item ellipsis">
                        <span className="main-content">{resultItem.title}</span>
                        <span className="other-content">, {resultItem.other}</span>
                    </div>
                </div>
            </li>
        );
    }
}

export default PointSearchResultListItem;
